module.exports = __webpack_public_path__ + "static/img/RAN_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAN_1.png
// module id = TKjv
// module chunks = 0